import { api } from 'api/api';
import type { BaseResponse } from 'api/api.types';
import type { UserInfo } from './dtos/getMe.dto';

export async function getMeApi() {
  const { data } = await api.get<BaseResponse<UserInfo>>('/user');
  return data.data;
}
